module.exports = __webpack_public_path__ + "img/ticket25.d1ffa1c1.png";